"use strict";
var r, e;
function a() {
  return e || (e = 1, r = Math.abs), r;
}
export {
  a as __require
};
//# sourceMappingURL=index.es310.js.map
